module.exports = __webpack_public_path__ + "static/media/about-city.38ebbf74.png";